/**
 * Highlight the searchValue and return the highlig
 * @param text
 * @returns
 */
const HighlightText = (searchValue: string | null, text: string): React.ReactNode => {
  if (!searchValue) return text;

  const regex = new RegExp(`(${searchValue})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? (
      <span key={index} className="highlight">
        {part}
      </span>
    ) : (
      part
    ),
  );
};

export default HighlightText;
